// @mui
import { styled } from '@mui/material/styles';
import { Card, Stack, Typography, Box, Container } from '@mui/material';
// components
import { MotionViewport, varFade } from '../../components/animate';
import TextMaxLine from '../../components/TextMaxLine';

import { m } from 'framer-motion';
import React, { useState } from 'react';
import Slider from 'react-slick';

// const DATA = [
//   {
//     title: 'Coopération',
//     desc: 'Candith Mashego-Dlamini explore des opportunités d’affaires au Togo',
//     url: '/assets/actualite/Dlamini_Mivedor.jpg',
//     redirect: 'https://togobreakingnews.info/mashego-dlamini-explore-opportunites-togo/',
//   },
//   {
//     title: 'Futur hub digital',
//     desc: 'Rose Kayi Mivédor, la ministre en charge de l’Investissement, l’assure, le Togo va devenir la Mecque des nouvelles technologies.',
//     url: '/assets/actualite/futur_hub_digital_i1920.jpeg',
//     redirect: 'https://www.republicoftogo.com/toutes-les-rubriques/politique/futur-hub-digital',
//   },
//   {
//     title: 'Transformation digitale',
//     desc: 'Le Togo pressenti comme future « Mecque des nouvelles technologies » en Afrique de l’ Ouest',
//     url: '/assets/actualite/FB_IMG_1678437989249-1.jpg',
//     redirect:
//       'https://www.digitalbusiness.africa/transformation-digitale-le-togo-pressenti-comme-future-meques-des-nouvelles-technologies-en-afrique-de-l-ouest/',
//   },
// ];

const PARTENAIRES_LIST = [
  {
    title: 'Office Togolais des Recettes (OTR)',
    image: '/assets/partenaire/otr.jpg',
    url: 'https://otr.tg',
  },
  {
    title: 'Direction Générale de la Documentation Nationale (DGDN)',
    image: '/assets/partenaire/dgdn.jpg',
    url: 'https://dgdn.gouv.tg',
  },

  {
    title: 'Togo Invest Corporation',
    image: '/assets/partenaire/togo_invest.jpg',
    url: 'https://togoinvest.tg',
  },
  {
    title: 'Port Autonome de Lomé (PAL)',
    image: '/assets/partenaire/port.jpg',
    url: 'https://www.togo-port.net',
  },
  {
    title: 'Alliance pour la Promotion du Port de Lomé (A2PL)',
    image: '/assets/partenaire/a2pl.png',
    url: 'https://a2pl.tg/',
  },

  {
    title: "Chambre de Commerce et d'Industrie du Togo (CCIT)",
    image: '/assets/partenaire/ccit.jpg',
    url: 'https://www.ccit.tg',
  },
  {
    title: 'Centre de Formalités des Entreprises (CFE)',
    image: '/assets/partenaire/cfe.jpg',
    url: 'https://www.cfetogo.tg',
  },

  {
    title: "Société d'Exploitation du Guichet Unique pour le Commerce Extérieur (SEGUCE TOGO)",
    image: '/assets/partenaire/seguce.jpg',
    url: 'https://www.segucetogo.tg',
  },
  {
    title: 'Association des Sociétés de Zone Franche (ASOZOF)',
    image: '/assets/partenaire/asozof.jpg',
    url: 'https://asozof.org',
  },

  {
    title: "Plateforme Industrielle d'Adétikopé (PIA)",
    image: '/assets/partenaire/pia.jpg',
    url: 'https://pia-togo.com',
  },
  {
    title: "Compagnie d'Énergie Électrique du Togo (CEET)",
    image: '/assets/partenaire/ceet.jpg',
    url: 'https://www.ceet.tg',
  },

  {
    title: 'Caisse Nationale de Sécurité Sociale (CNSS)',
    image: '/assets/partenaire/cnss.jpg',
    url: 'https://cnss.tg',
  },
  {
    title: 'Yas Togo',
    image: '/assets/partenaire/yas.png',
    url: 'https://www.yas.tg',
  },
  {
    title: 'Togolaise des Eaux (TdE)',
    image: '/assets/partenaire/tde.jpg',
    url: 'https://www.tde.tg',
  },
  {
    title: 'e-Foncier (OTR)',
    image: '/assets/partenaire/e_foncier.jpg',
    url: 'https://e-foncier.otr.tg/',
  },

  {
    title: 'Agence des États-Unis pour le développement international (USAID)',
    image: '/assets/partenaire/usaid.jpg',
    url: 'https://www.usaid.gov/',
  },
  {
    title: 'Organisation des Nations Unies pour le développement industriel (ONUDI)',
    image: '/assets/partenaire/onud.jpg',
    url: 'https://www.unido.org/',
  },

  {
    title: 'Overseas Private Investment Corporation (OPIC)',
    image: '/assets/partenaire/opic.jpg',
    url: 'https://www.opic.gov/',
  },
  {
    title: 'Programme des Nations Unies pour le développement (PNUD)',
    image: '/assets/partenaire/pnud.jpg',
    url: 'https://www.undp.org/fr/togo',
  },
];

// ----------------------------------------------------------------------

const ContentStyle = styled('div')(({ theme }) => ({
  width: '100%',
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(10),
  textAlign: 'center',
  backgroundImage: 'url(/assets/background/Temoignage.jpg)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
}));

// ----------------------------------------------------------------------

export default function HomeTemoignage() {
  const settings2 = {
    dots: false,
    infinite: true,
    arrows: false,
    centerMode: false,
    swipeToSlide: true,
    focusOnSelect: true,
    variableWidth: false,
    centerPadding: '0px',
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 2000,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1400,
        settings: { slidesToShow: 5 },
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 900,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 2 },
      },
    ],
  };

  // Ouvre le site du partenaire dans un nouvel onglet
  const handleLogoClick = (link) => {
    window.open(link, '_blank');
  };


  return (
    <Stack width={1} component={MotionViewport}>
      <ContentStyle>
        <Container>
          <Stack width={1} alignItems="center" mb={3}>
            <m.div variants={varFade().inUp}>
              <Typography textAlign="center" variant="h3" color="common.white">
                Ils contribuent à lʼécosystème dʼinvestissement au Togo
              </Typography>
            </m.div>
            <m.div variants={varFade().inUp}>
              <Stack width={1} alignItems="center">
                <Box height={8} width={150} bgcolor="#1E5649" />
              </Stack>
            </m.div>
          </Stack>
        </Container>

        <Stack width={1} px={{ xs: 2, sm: 3, md: 5 }}>
          <Slider adaptiveHeight {...settings2}>
            {PARTENAIRES_LIST.map(({ title, image, url }) => (
              <Box key={url + image} px={{ xs: 0.75, md: 1.25 }} py={1}>
                <PartnerCard title={title} image={image} onClick={() => handleLogoClick(url)} />
              </Box>
            ))}
          </Slider>
        </Stack>
      </ContentStyle>
    </Stack>
  );
}

// Affiche une carte partenaire avec titre au survol en bas de l'image
const PartnerCard = ({ title, image, onClick }) => {
  const [hover, setHover] = useState(false);

  return (
    <Card
      elevation={10}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={{
        position: 'relative',
        overflow: 'hidden',
        p: { xs: 1, md: 1.5 },
        width: '100%',
        aspectRatio: '1 / 1',
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
      }}
    >
      <Box
        component="img"
        src={image}
        alt={title}
        sx={{
          width: '75%',
          height: '75%',
          objectFit: 'contain',
        }}
      />

      <Stack
        position="absolute"
        left={0}
        right={0}
        bottom={0}
        alignItems="center"
        justifyContent="center"
        spacing={1}
        px={1.5}
        py={1.5}
        sx={{
          bgcolor: 'rgba(0, 0, 0, 0.65)',
          height: hover ? '45%' : 0,
          opacity: hover ? 1 : 0,
          transition: 'height 0.35s ease-in-out, opacity 0.35s ease-in-out',
          overflow: 'hidden',
        }}
      >
        <Box height={5} width={40} bgcolor="warning.main" flexShrink={0} />
        <TextMaxLine
          line={3}
          variant="body2"
          fontSize={12}
          color="common.white"
          fontWeight="bold"
          sx={{ textAlign: 'center' }}
        >
          {title}
        </TextMaxLine>
      </Stack>
    </Card>
  );
};



// const CardTem = ({ item, isCenter }) => {
//   const { title, url, desc, redirect } = item;

//   const navigate = () => {
//     window.open(redirect, '_blank');
//   };

//   return (
//     <Stack
//       m={3}
//       mb={1}
//       mt={!isCenter ? 3 : 0}
//       spacing={2}
//       sx={{ ':hover': { textDecoration: 'underline', color: 'common.white' } }}
//       onClick={navigate}
//     >
//       <Stack
//         component={Card}
//         sx={{
//           backgroundImage: `url(/assets/clearoverlay.svg), url(${url})`,
//           backgroundPosition: 'center',
//           backgroundSize: 'cover',
//           height: isCenter ? 250 : 220,
//           cursor: 'pointer',
//         }}
//       />
//       <TextMaxLine variant="h3" color="common.white">
//         {title}
//       </TextMaxLine>
//       <TextMaxLine line={isCenter ? 3 : 2} variant="h5" color="common.white">
//         {desc}
//       </TextMaxLine>
//     </Stack>
//   );
// };
